import styled from "styled-components";
import {
  MOBILE,
  TABLET,
  BodyTextLarge,
  EXTRA_LARGE,
} from "@minerva-analytics/pantheon";
import {
  BACKGROUND_COLOR,
  GRAY,
  PRIMARY_FONT_TEXT,
  TITLE_COLOR,
  TITLE_FONT,
} from "../../theme";
import {
  COMING_SOON_BACKGROUND_IMAGE,
  COMING_SOON_IMAGE_MOBILE,
} from "../../image-links";

const ComingSoonContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${MOBILE}) {
    align-items: flex-start;
  }
`;

const ComingSoonBody = styled(BodyTextLarge)`
  text-align: center;
  line-height: 33px;
  font-size: 18px;
  font-family: ${PRIMARY_FONT_TEXT};
  color: ${GRAY};
  && {
    text-align: center;
  }

  @media (max-width: ${MOBILE}) {
    text-align: left;
    margin: 2rem;
  }
`;

const ComingSoonImageContainer = styled.div`
  background-image: url(${COMING_SOON_BACKGROUND_IMAGE});
  width: 100%;
  display: flex;
  height: 450px;
  background-size: cover;
  margin-top: 2rem;
  overflow: hidden;
  flex-direction: column;

  @media (min-width: ${TABLET}) {
    height: 800px;
  }

  @media (max-width: ${MOBILE}) {
    height: 100%;
  }
`;

const ComingSoonImage = styled.img`
  margin: auto;
  max-width: 50%;

  @media (max-width: ${MOBILE}) {
    content: url(${COMING_SOON_IMAGE_MOBILE});
    max-width: 10rem;
    margin: 0 auto;
    margin-top: 2rem;
  }
`;

const CircleImage = styled.img`
  margin: auto;
  width: 53px;
  padding-bottom: 25px;
`;

const Background = styled.div`
  background-color: ${BACKGROUND_COLOR};
  @media (min-width: ${EXTRA_LARGE}) {
    position: absolute;
    top: 0px;
    height: 100%;
    right: 0px;
    width: 100%;
  }
  z-index: -1;
`;

const ArticleTitle = styled.div`
  margin: 1rem 0;
  color: ${TITLE_COLOR};
  text-align: left;
  font-family: ${TITLE_FONT};
  font-weight: bold;
  font-size: 50px;
  letter-spacing: 1.05px;

  @media (max-width: ${MOBILE}) {
    font-size: 1.75rem;
    text-align: center;
  }
  @media (max-width: ${TABLET}) {
    margin: 1rem 1rem;
  }
`;

export {
  ArticleTitle,
  ComingSoonContainer,
  ComingSoonImage,
  ComingSoonBody,
  CircleImage,
  Background,
  ComingSoonImageContainer,
};
